const path = require('path')

const router = require('../../router')


module.exports = async(graphql, actions, route) => {
  const { createPage } = actions
  const pageContainer = path.resolve('src/containers/Page/index.js')
  const pagesQuery = await graphql(
    `
      query {
        allContentfulPage {
          edges {
            node {
              slug
            }
          }
        }
      }
    `
  )

  const pagesSlugs = pagesQuery.data.allContentfulPage.edges.map((e) => e.node.slug)
  const uniqPagesSlugs = [...new Set(pagesSlugs)]

  uniqPagesSlugs.forEach(async(slug) => {
    if (!slug) {
      throw new Error('Slug not defined')
    }
    await createPage({
      path: router(route.path, { slug }),
      component: pageContainer,
      context: {
        slug,
        isVip: !!route.isVip,
      },
    })
  })
}
